import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/endpoints';
import type { TaxYearConfigResponse } from '../types/taxYear.types';

const FALLBACK_MIN = 2010;
const FALLBACK_MAX = 2026;

/** Backend-aligned fallback when GET /api/tax-year fails */
export function getFallbackTaxYearConfig(): TaxYearConfigResponse {
  const supportedYears: number[] = [];
  for (let y = FALLBACK_MIN; y <= FALLBACK_MAX; y++) {
    supportedYears.push(y);
  }
  const calendarDefault = new Date().getFullYear() - 1;
  const defaultTaxYear = Math.min(
    FALLBACK_MAX,
    Math.max(FALLBACK_MIN, calendarDefault)
  );
  return { supportedYears, defaultTaxYear };
}

/**
 * Get supported tax years and default from the server (GET /api/tax-year).
 * Used to populate year selectors and preselect the default.
 */
export async function getTaxYearConfig(): Promise<TaxYearConfigResponse> {
  const response = await apiClient.get<TaxYearConfigResponse>(
    API_ENDPOINTS.TAX_YEAR_CONFIG
  );
  return response.data;
}

/**
 * Get default tax year from server.
 * Prefer getTaxYearConfig() when both the list and default are needed.
 */
export async function getDefaultTaxYear(): Promise<number> {
  const config = await getTaxYearConfig();
  return config.defaultTaxYear;
}
